import Services from './js-services/services';

// no typings available from MSoft for this ... for some reason
// https://github.com/dotnet/aspnetcore/issues/10124
(window as any).Blazor.registerCustomEventType('roottemplatechange', {
  createEventArgs: function (event: UIEvent) {
    return {
      detail: event.detail
    };
  },
});

(window as any).Blazor.registerCustomEventType('jobadded', {
  createEventArgs: function (event: UIEvent) {
    return {
      detail: event.detail
    };
  }
});

(window as any).Blazor.registerCustomEventType('jobupdated', {
  createEventArgs: function (event: UIEvent) {
    return {
      detail: event.detail
    };
  }
});

(window as any).Blazor.registerCustomEventType('jobdeleted', {
  createEventArgs: function (event: UIEvent) {
    return {
      detail: event.detail
    };
  }
});

(window as any).Blazor.registerCustomEventType('childjobadded', {
  createEventArgs: function (event: UIEvent) {
    return {
      detail: event.detail
    };
  }
});

(window as any).Blazor.registerCustomEventType('recurringjobexceptionadded', {
  createEventArgs: function (event: UIEvent) {
    return {
      detail: event.detail
    };
  }
});

const token: string = 'Mpro';
const Mpro = (globalThis as any)[token] = (globalThis as any)[token] || {};

// assign instance of the services to the window
Object.assign(Mpro, Services);
